export default {
    getSampleState: state => {
        return state.sampleState;
    },
    getMainInfo: state => {
        return state.mainInfo;
    },
 
    getEndPoint: state => {
        return state.endPoint;
    },
    getCallBack: state => {
        return state.whenSuccessCallback;
    },
    getProfileId: state => {
        return state.profileId;
    },
     
    getMainDataStructure: state => {
        var objCount = Math.ceil(Object.entries(state.mainDataStructure).length / 2);
       
        var filtered = _.filter(state.mainDataStructure, ['showInView', 'yes']);

        return _.chunk(filtered, objCount);
    },
    getOrigDataStructure: state => {
        return state.mainDataStructure;
    },
    getDataStructureInChunk: state => {
        
        var objCount = Math.floor(Object.entries(state.mainDataStructure).length / 2);
        var object = _.pickBy(state.mainDataStructure, ['showInView', 'yes']);

        const arrayFromObject = Object.entries(object);
        return _.chunk(arrayFromObject, objCount);
    },
    
    getDataStructureInChunkForForm: state => { 
        var object = _.pickBy(state.mainDataStructure, ['showInForm', 'yes']);
        const arrayFromObject = Object.entries(object);
        var objCount = Math.ceil(arrayFromObject.length / 2); 
        return _.chunk(arrayFromObject, objCount);
    },
    getDataStructureNoChunk: state => { 
        var object = _.pickBy(state.mainDataStructure, ['showInForm', 'yes']); 
        return Object.entries(object); ;
    },

    getCurrentMainInfo: state => {
        return state.currentMainInfo;
    },
    getCurrentDataStructureInChunk: state => {
        console.log('state.currentStructure:',state.currentDataStructure);
        var objCount = Math.ceil(Object.entries(state.currentDataStructure).length / 2);
        var object = _.pickBy(state.currentDataStructure, ['showInView', 'yes']);
 
        const arrayFromObject = Object.entries(object);
        console.log("arrayFromObject:",arrayFromObject);
        return _.chunk(arrayFromObject, objCount);
    },

    getCurrentDataStructureInChunkForView: state => { 
        var objCount = Math.ceil(Object.entries(state.currentDataStructure).length / 2);
        var object = _.pickBy(state.currentDataStructure, ['showInUpdate', 'yes']);
 
        const arrayFromObject = Object.entries(object);
        console.log("arrayFromObject:",arrayFromObject);
        return _.chunk(arrayFromObject, objCount);
    },

    getOrigCurrentDataStructure: state => {
        return state.currentDataStructure;
    },


}